/**
 * Full-page navigation (plan 124). A thin seam over
 * `window.location.assign` so unit tests can mock the navigation —
 * jsdom's `location.assign` is non-configurable and can't be spied on.
 */
export function hardNavigate(url: string): void {
  window.location.assign(url);
}
